/**
 * Styled Components - Created by Alfredo on 02/05/25.
 */
import styled from 'styled-components'
import { WHITE } from '../../theme/colors'
import Rate from 'react-star-ratings'
import Modal from 'antd/lib/modal/Modal'

export const Container = styled.div`
  padding-bottom: 36px;
  width: 100%;
  margin-top: -16px;
  font-family: "Avenir Next";
  display: flex;
  align-items: flex-start;
  }
`

export const GetSizeRecContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 22px;
  justify-content: space-around;
  flex-direction: column;
  align-items: start;
  border-radius: 8px;
  background: #F7F7F7;
  color: #000;
  font-family: "Avenir Next";
  &.profile {
    margin-left: 20px;
    max-width: 330px;
    @media (max-width: 698px) {
      margin-left: unset;
      max-width: unset;
    }
  }
  &>h1 {
    font-size: 20px;
    font-weight: 500;
    @media (max-width: 698px) {
      margin-top: 20px;
    }
  }
  &>p {
    color: #625F5F;
    margin-top: 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    span {
      font-weight: 600;
      color:  #625F5F;
      font-size: 16px;
      line-height: normal;
    }
    &.note {
      margin-bottom: 0px;
      color: #817E7E;
      font-style: italic;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: -0.12px;
      line-height: 20px;
    }
  }
  &>button {
    /* width: 100%; */
    padding-block: 10px;
    padding-inline: 48px;
    margin-top: 16px;
    display: flex;
    justify-content: center;
    border-radius: 50px;
    border: 1.5px solid #302628;
    background: #302628;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    color: ${WHITE};
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    cursor: pointer;
    @media (min-width: 768px) {
      order: 1 !important;
    }
  }
  &>button:disabled, .disabledBtn {
    border: 1.5px solid #8F8889;
    background: #E8E5E5;
    color: #8F8889;
    white-space: nowrap;
    @media (max-width: 698px) {
      width: 100%;
    }
  }
  @media (max-width: 698px) {
    margin-top: 20px;
    margin-left: 0px;
    max-width: unset;
  }
`

export const ConfirmMeasurementsModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-modal-footer {
    border-top: 0;
    padding: 16px 38px 24px;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    width: 100%;
  }

  .ant-modal-footer .ant-btn {
    border-radius: 4px;
    flex-basis: 48%;
    font-family: Avenir;
    font-size: 14px;
    font-weight: 600;
    height: 44px;
    line-height: normal;
    margin: 0 !important;
  }

  .ant-modal-footer .ant-btn-primary {
    background: #302628;
    border: 1.5px solid #302628;
    box-shadow: none;
    color: white;
    order: 1;
    text-shadow: none;
  }

  .ant-modal-footer .ant-btn:not(.ant-btn-primary) {
    background: white;
    border: 2px solid #302628;
    color: #302628;
    order: 2;
  }

  @media (max-width: 698px) {
    max-width: 94vw

    .ant-modal-footer {
      padding: 24px 16px 31px;
    }

    .ant-modal-footer > div {
      flex-flow: column;
    }

    .ant-modal-footer .ant-btn {
      flex: unset;
      font-size: 14px;
      height: 44px;
      line-height: normal;
      font-weight: 600;
      letter-spacing: 0.5px;
      width: 100%;
    }

    .ant-modal-footer .ant-btn-primary {
      margin-bottom: 22px !important;
      margin-right: 0 !important;
    }

    .ant-modal-footer .ant-btn:not(.ant-btn-primary) {
      margin-right: 0 !important;
    }
  }
`

export const ConfirmMeasurementsContent = styled.div`
  color: #302628;
  font-family: Avenir;
  padding: 18px 14px 0;
  .confirm-measurements-header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  .confirm-measurements-close {
    cursor: pointer;
    font-size: 28px;
    line-height: 1;
    position: absolute;
    right: 0;
    top: -22px;
  }

  .confirm-measurements-title {
    font-size: 22px;
    font-weight: 500;
    line-height: 40px;
  }

  .confirm-measurements-copy {
    font-size: 14px;
    line-height: 20px;
    margin-top: 40px;

    p {
      margin-bottom: 14px;
    }
  }

  .confirm-measurements-grid {
    align-items: center;
    background: #F7F7F7;
    display: flex;
    justify-content: space-between;
    margin-top: 36px;
    padding: 16px 24px;
  }

  .confirm-measurements-column {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .confirm-measurements-row {
    align-items: center;
    display: flex;
    font-size: 14px;
    line-height: normal;

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  .confirm-measurements-label {
    font-weight: 700;
    margin-right: 6px;
  }

  @media (max-width: 698px) {
    padding: 26px 16px 0;
    .confirm-measurements-close {
      font-size: 28px;
      top: -4px;
    }

    .confirm-measurements-title {
      font-size: 20px;
      line-height: normal;
      max-width: 240px;
    }

    .confirm-measurements-copy {
      font-size: 12px;
      line-height: 20px;
      margin-top: 18px;

      p {
        margin-bottom: 18px;
      }
    }

    .confirm-measurements-grid {
      align-items: start;
      column-gap: 20px;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      margin-top: 26px;
      padding: 24px 22px;
      row-gap: 20px;
    }

    .confirm-measurements-column {
      display: contents;
    }

    .confirm-measurements-row {
      font-size: 16px;
      justify-content: flex-start;
      line-height: 25px;

      &:not(:last-child) {
        margin-bottom: 0;
      }
    }
  }
`

export const DesktopEmptyTable = styled.div`
  max-width: 698px;
  margin-top: 12px;
  width: 100%;
`

export const TableContainer = styled.div`
  min-width: fit-content;
  color: #302628;
  .action-cell {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.14px;
    max-width: 142px;
    text-transform: none;
  }
  .action-cell.get-measured {
    color: #FF3B30;
  }
  .action-cell.give-feedback {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    border-radius: 200px;
    border: 1px solid #34C759;
    background: #FFF;
    color: #34C759;
    &:hover {
      background: #34C759;
      color: white;
    }
  }
  .text-mobile {
    display: none;
  }
  @media (max-width: 698px) {
    .text-desktop {
      display: none;
    }
    .text-mobile {
      display: inline;
      i {
        margin-inline: 6px;
        font-size: 16px;
      }
    }
  }
  .item-card {
    display: none;
    @media (max-width: 698px) {
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      border: 1px solid #D7D1D2;
      background: #FFF;
      box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, 0.15);
      .fdb {
        color: #A8A0A1;
        flex-direction: row;

        & > *:not(:last-child) {
          margin-right: 10px;
        }
      }
      &>div {
        display: flex;
        align-items: start;
        justify-content: space-between;
        padding: 16px 22px;
        color: #000;
        :not(last-child) {
          border-bottom: 1px solid #D7D1D2;
        }
        &>div {
          display: flex;
          flex-direction: column;
          text-transform: uppercase;
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
          letter-spacing: -0.03px;
          &.action-cell {
            text-transform: none;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            letter-spacing: 0.14px;
          }
          &.give-feedback {
            border: none;
            display: flex;
            flex-direction: row;
          }
          span {
            color: #A8A0A1;
            :last-child {
              padding-block: 1px;
              color: #302628;
              text-transform: none;
              font-size: 14px;
              font-weight: 500;
              line-height: 18px;
              letter-spacing: -0.035px;
            }
          }
        }
      }
    }
  }
  #cta-container {
    display: flex;
    max-width: 900px;
    min-height: 220px;
    margin-bottom: 12px;
    @media (max-width: 698px) {
      min-height: unset;
    }
    #empty-state {
      max-width: 900px;
      width: 100%;
      @media (max-width: 698px) {
        display: none;
      }
    }
    #feedback-state {
      @media (max-width: 698px) {
        flex-basis: unset;
        width: 100%;
        margin-inline: 16px;
      }
    }
  }
  #empty-state-mobile {
    display: none;
    @media (max-width: 698px) {
      display: block;
    }
  }
  table {
    max-width: fit-content;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0 12px;
    background: #F7F7F7;
    @media (max-width: 698px) {
      border-collapse: unset;
      border-spacing: 0;
      th:not(:first-child),
      td:not(:first-child) {
        display: none;
      }
      td:first-child {
        width: 100vw;
      }
    }
    thead {
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 700;
      line-height: 18px;
      letter-spacing: -0.027px;
      th {
        padding-inline: 16px;
        text-align: left;
      }
      @media (max-width: 698px) {
        display: none;
      }
    }
    tbody td {
      padding: 16px;
      vertical-align: middle;
      h1 {
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.035px;
        @media (max-width: 698px) {
          color: #302628;
          line-height: 16px;
        }
      }
    }
    .table-row {
      height: 56px;
      cursor: pointer;
      background: #FFF;
      padding-bottom: 28px;
    }
  }
  .status {
    padding-inline: 6px;
  }
  .status.badge {
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    height: 24px;
    letter-spacing: -0.035px;
    text-transform: capitalize;
  }
  .pending {
    background: #FF3B30;
    color: ${WHITE};
  }
  .processing {
    background: #FF9500;
  }
  .completed {
    background: #34C759;
  }
  .unconfirmed {
    background: #dcdcdc;
  }
  .date {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.035px;
  } 
`

export const StyledRate = styled(Rate)``


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecs/styledComponents.tsx